import React, {  } from 'react';
import {
    StyleSheet,
    Text,
    View,
    TouchableOpacity} from 'react-native';

export default function Setting({ navigation }: any) {

    return (
        <View style={styles.container}>
            <View style={styles.versionBox}>
                <Text style={styles.title}>버전 :</Text>
                <Text style={styles.versionFont}>1.0</Text>
            </View>
            <TouchableOpacity style={styles.buttonBox}>
                <Text style={styles.buttonFont}>업데이트</Text>
            </TouchableOpacity>
        </View>
    )
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        padding: 40
    },
    versionBox: {
        flexDirection: 'row', 
        alignItems: 'center',
        marginBottom: 40
    },
    title: {
        fontSize: 22,
        color: '#000',
        fontWeight: '600',
        marginRight: 20
    },
    versionFont: {
        fontSize: 18,
        color: '#000'
    },
    buttonBox: {
        paddingHorizontal: 20,
        paddingVertical: 8,
        borderWidth: 1,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#202D3C',
        alignSelf: 'flex-start'
    },
    buttonFont: {
        fontSize: 18,
        fontWeight: '600',
        color: '#FBE9E7'
    }
});
